var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DialogPatientCreate'),_c('DialogPatientDelete'),(_vm.name === 'patients')?_c('Page',{staticClass:"page__patients"},[_c('PageRow',[_c('VCol',{attrs:{"cols":"12"}},[_c('PatientsList')],1)],1)],1):_c('ExtendedRouterView')],1)}
var staticRenderFns = []

export { render, staticRenderFns }